import { FormControl, FormLabel, Stack } from '@chakra-ui/react';
import { Field } from 'formik';
import { useState } from 'react';

import FieldError from 'components/forms/new/FieldError';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import NumberField from 'components/forms/new/formikFormFields/NumberField';
import {
    formInputStyles,
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';

const MinChannelsField = ({ errors, touched, darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            isRequired
            isInvalid={!!errors.minChannels && touched.minChannels}
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={{ ...stackStyling(), ...formInputStyles }}>
                <FormLabel sx={formLabelStyling(darkMode)}>
                    Minimum Channels
                </FormLabel>
                <Field
                    name="minChannels"
                    render={({ field }) => (
                        <NumberField
                            {...field}
                            min={0}
                            customWidth="100%"
                            placeholder="Enter minimum channels"
                            darkMode={darkMode}
                        />
                    )}
                />
                {isHovered && (
                    <FieldToolTip
                        label="The minimum number of channels for this trunk type."
                        ariaLabel="trunk-type-min-channels-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
            <FieldError isDrawer={false}>{errors?.minChannels}</FieldError>
        </FormControl>
    );
};

export default MinChannelsField;
